//#region src/assets/refresh-icon-large.svg
var refresh_icon_large_default = "" + new URL("refresh-icon-large-CrOiCQ9G.svg", import.meta.url).href;
//#endregion
export { refresh_icon_large_default as default };

//# sourceMappingURL=refresh-icon-large.js.map